for (let i = 0; i < document.querySelectorAll('.arva-anim').length; i++) {
    var animation = bodymovin.loadAnimation({
        container: document.querySelectorAll('.arva-anim')[i],  // Required
        path: '/wp-content/themes/33degres/src/public/json/animation-arva.json', // Required
        renderer: 'svg', // Required
        loop: true, // Optional
        autoplay: true, // Optional
        name: "Arva Anim", // Name for future reference. Optional.
    })
}